export default {
    remove: 'Verwijder',
    save: 'Opslaan',
    cancel: 'Annuleren',
    loading: 'Laden…',
    value: 'Waarde',
    'action-bar.collapse': 'Inklappen',
    'action-bar.expand': 'Uitklappen',
    'action-bar.actions': 'Acties',
    'callout.note': 'Opmerking',
    'callout.important': 'Belangrijk',
    'callout.tip': 'Tip',
    'callout.caution': 'Waarschuwing',
    'callout.warning': 'Waarschuwing',
    'collapsible-section.open': 'Open { header } sectie',
    'collapsible-section.close': 'Sluit { header } sectie',
    'date-picker.today': 'Vandaag',
    'date-picker.month.heading': 'Maand',
    'date-picker.quarter.heading': 'Kwartaal',
    'date-picker.year.heading': 'Jaar',
    'chip-set.clear-all': 'Alles wissen',
    'snackbar.dismiss': 'Sluiten',
    'file.drag-and-drop-tips':
        'Sleep een bestand hierheen of klik om te bladeren.',
    'file-viewer.message.unsupported-filetype':
        'Kan geen voorbeeld weergeven voor dit bestandstype.',
    'file-viewer.message.try-other-options':
        'Download het bestand of open het in een nieuw tabblad.',
    'file-viewer.download': 'Downloaden',
    'file-viewer.exit-fullscreen': 'Verlaat volledig scherm',
    'file-viewer.open-in-fullscreen': 'Open in volledig scherm',
    'file-viewer.open-in-new-tab': 'Openen op een nieuw tabblad',
    'file-viewer.more-actions': 'Meer…',
    'editor-menu.bold': 'Vet',
    'editor-menu.italic': 'Cursief',
    'editor-menu.strikethrough': 'Doorhalen',
    'editor-menu.h1': 'Kopniveau 1',
    'editor-menu.h2': 'Kopniveau 2',
    'editor-menu.h3': 'Kopniveau 3',
    'editor-menu.bulleted-list': 'Opsomming',
    'editor-menu.numbered-list': 'Genummerde lijst',
    'editor-menu.blockquote': 'Blokcitaat',
    'editor-menu.link': 'Link toevoegen',
    'editor-link-menu.text': 'Tekst',
    'editor-link-menu.link': 'Link',
    'editor-menu.code-block': 'Codeblok',
    'editor-menu.code': 'Code',
    'editor-image-view.loading': 'Afbeelding wordt geladen: { filename }...',
    'editor-image-view.failed':
        'Er is iets misgegaan met de afbeelding: { filename }',
    'editor-image-view.success': 'Afbeelding: { filename } is klaar',
    'editor-image-view.resize-handle':
        'Sleep naar rechts of links om de afbeeldingsgrootte te veranderen',
    'progress-bar': 'Voortgangsbalk',
    'ai-avatar.label': 'AI-avatar',
    'ai-avatar.thinking': 'aan het denken',
    'table.select-all': 'Alle rijen selecteren',
    'table.select-row': 'Deze rij selecteren',
    'profile-picture.remove': 'Geselecteerde afbeelding verwijderen',
    'profile-picture.unsupported-preview.title':
        'Niet-ondersteund afbeeldingsformaat',
    'profile-picture.unsupported-preview.description':
        'We kunnen de geselecteerde afbeelding niet weergeven in deze browser. Selecteer een ander afbeeldingsbestand.',
};
